import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['detailSearchField', 'read', 'unreadCheck', 'result', 'arrivalAirport', 'searchButton'];

  static values = {
    currentQuery: String,
    defaultStatuses: Array,
    currentCustomerId: String,
  };

  static storageKey = 'customer-transport-request-search';

  static excludedFields = ['q[arrival_airport_eq]', 'q[has_unread]', 'transport_method'];

  connect() {
    const storedParams = sessionStorage.getItem(this.constructor.storageKey);
    if (!storedParams) return;

    // 現在のURLにクエリパラメータがない場合のみ検索を実行
    const shouldExecuteSearch = !window.location.search;
    this.restore(JSON.parse(storedParams), shouldExecuteSearch);
  }

  showDetailSearchField() {
    this.detailSearchFieldTarget.classList.remove('hidden');
  }

  hideDetailSearchField() {
    this.detailSearchFieldTarget.classList.add('hidden');
  }

  startSearch() {
    this.searchButtonTarget.click();
  }

  changeArrivalAirportHandler() {
    const params = new URLSearchParams(this.currentQueryValue);
    const arrivalAirport = this.arrivalAirportTarget.value || '';
    const paramsAirport = params.get('q[arrival_airport_eq]') || '';

    if (paramsAirport !== arrivalAirport) {
      this.startSearch();
    }
  }

  changeUnreadHandler() {
    this.startSearch();
  }

  clear() {
    // すべてのテキスト系フィールドをクリア
    this.element.querySelectorAll('input[type="text"], input[type="date"], textarea').forEach((field) => {
      if (!this.constructor.excludedFields.includes(field.name)) {
        field.value = '';
      }
    });

    // selectコンポーネントをクリア
    this.element.querySelectorAll('[data-controller*="select"]').forEach((selectComponent) => {
      const hiddenSelect = selectComponent.querySelector('select[data-select-target="hiddenSelect"]');
      if (hiddenSelect && !this.constructor.excludedFields.includes(hiddenSelect.name)) {
        const controller = this.application.getControllerForElementAndIdentifier(selectComponent, 'select');
        controller.resetSelection();
      }
    });

    // 初期値を設定
    this.setDefaultFields();
  }

  setDefaultFields() {
    this.setDefaultStatuses();
    this.setDefaultCustomer();
  }

  setDefaultStatuses() {
    this.setSelectDefaultValues('q[status_in][]', this.defaultStatusesValue);
  }

  setDefaultCustomer() {
    this.setSelectDefaultValues('q[customer_id_in][]', [this.currentCustomerIdValue]);
  }

  setSelectDefaultValues(fieldName, values) {
    const targetSelect = this.element.querySelector(`select[name="${fieldName}"]`);
    const selectComponent = targetSelect.closest('[data-controller*="select"]');
    const controller = this.application.getControllerForElementAndIdentifier(selectComponent, 'select');
    controller.setValuesToMultipleSelect(values);
  }

  // sessionStorageから検索条件を取り出して、フォームに復元
  restore(params, shouldExecuteSearch = false) {
    Object.entries(params).forEach(([name, values]) => {
      // 除外対象のフィールドはスキップ
      if (this.constructor.excludedFields.includes(name)) {
        return;
      }

      const fields = this.element.querySelectorAll(
        `[name="${name}"]:not([type="hidden"])`,
      );

      fields.forEach((field) => {
        // 複数選択可能なselectの復元
        if (field.tagName === 'SELECT' && field.multiple) {
          Array.from(field.options).forEach((opt) => {
            opt.selected = values.includes(opt.value);
          });
          return;
        }

        field.value = values;
      });
    });

    // フラグがtrueの場合のみ検索を実行（無限ループ防止）
    if (shouldExecuteSearch) {
      this.startSearch();
    }
  }

  // 「この条件で検索」ボタン押下時、sessionStorageに検索条件を保存
  store() {
    const params = {};

    this.element.querySelectorAll('[name]:not([type="hidden"])').forEach((field) => {
      const { name } = field;

      // 除外対象のフィールドはスキップ
      if (this.constructor.excludedFields.includes(name)) {
        return;
      }

      // 複数選択可能なselectの復元
      if (field.tagName === 'SELECT' && field.multiple) {
        params[name] = Array.from(field.selectedOptions).map((opt) => opt.value);
        return;
      }

      params[name] = field.value;
    });

    sessionStorage.setItem(this.constructor.storageKey, JSON.stringify(params));
  }
}
